import apiClient from "../api/apiClient";

export const getDashboardData = async (userId) => {
  try {
    const response = await apiClient.get(`/dashboard/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

export const getAdminDashboardStats = async () => {
  try {
    const res = await apiClient.get(`/dashboard/admin`);
    return res.data;
  } catch (error) {
    console.error("Error fetching admin dashboard data:", error);
    throw error;
  }
};